
import { ROUTE_TYPE } from 'rde-view-common/constants/Routes';
import MessageIds from 'rde-view-common/locales/MessageIds';
import { signOut } from 'rde-view-common/middleware/auth';
import RouteConfig from '~/config/routeConfig';

/**
 * 共通ヘッダ
 */
export default {
  Name: 'Header',
  data: () => {
    return {
      MessageIds,
      loginUser: {}
    };
  },
  computed: {
    loginUserId() {
      return this.$store.state.loginUser.id;
    }
  },
  watch: {
    loginUserId() {
      this.loginUser = this.$store.state.loginUser;
    }
  },
  created() {
    this.loginUser = this.$store.state.loginUser;
  },
  methods: {
    signOut() {
      signOut();
    },
    getSrc(path) {
      return (this.$config.viewBaseUrl.basePath || '') + path;
    },
    toUserProfile() {
      window.open(this.$rdeRouter.resolve(this.$routes.USERS_PROFILE, { id: this.loginUser.id }), '_blank');
    },
    openHelp() {
      const viewBaseUrlObj = this.$config.viewBaseUrl;

      let baseUrl;
      let appDirName = '';
      switch (RouteConfig.ME) {
        case ROUTE_TYPE.DATASETS:
          baseUrl = this.$config.viewBaseUrl[RouteConfig.ME];
          appDirName = 'datasets';
          break;
        case ROUTE_TYPE.ENTRIES:
          baseUrl = Object.keys(viewBaseUrlObj)
            .filter(key => viewBaseUrlObj[key].startsWith(location.origin))
            .map(key => viewBaseUrlObj[key])[0];
          appDirName = 'entries';
          break;
        case ROUTE_TYPE.INSTRUMENTS:
          baseUrl = this.$config.viewBaseUrl[RouteConfig.ME];
          appDirName = 'instruments';
          break;
        case ROUTE_TYPE.SAMPLES:
          baseUrl = this.$config.viewBaseUrl[RouteConfig.ME];
          appDirName = 'samples';
          break;
        case ROUTE_TYPE.USERS:
          baseUrl = this.$config.viewBaseUrl[RouteConfig.ME];
          appDirName = 'users';
          break;
      }
      const path = `/home/mdpf/help/${appDirName}/help.pdf`;
      window.open(baseUrl + path, '_blank');
    }
  }
};
